import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import { scale } from '../../utils/scale.utils';
import BaseText from '../BaseText';
import Icon from '../Icon';
import Modal from '../Modal';
import RowView from '../RowView';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';

const SubmitExpenseModal = ({ visible, onClose, item }) => {
  const { t } = useTranslation(i18nNS.tripExpense);
  const { tKey } = useComponentTKey('ExpenseScreen');
  return (
    <Modal visible={visible} transparent>
      <View style={stylesModal.wrap}>
        <View style={stylesModal.innerWrap}>
          <TouchableOpacity onPress={onClose} style={stylesModal.cancel}>
            <Icon name="cancel" color={Color.primary} size={18} />
          </TouchableOpacity>
          <Icon name="circleCheck" size={56} color={Color.primary} />
          <BaseText style={stylesModal.title}>{t(tKey('YouSet'))}</BaseText>
          <BaseText style={stylesModal.subtitle}>{t(tKey('SubmittedExpense'))}</BaseText>
          <View style={stylesModal.border} />
          <BaseText style={CommonStyles.h3}>{item?.Name}</BaseText>
          <RowView style={stylesModal.details}>
            <BaseText style={stylesModal.date}>
              {item?.Expenses && item.Expenses.length > 0
                ? moment(item.Expenses[item.Expenses.length - 1].ChargeDate).format('MMM DD, YYYY')
                : null}
            </BaseText>
            {item?.Expenses ? (
              <BaseText style={CommonStyles.h3}>{`${item.Expenses.length} ${
                item.Expenses.length === 1 ? t(tKey('Expense')) : t(tKey('Expenses'))
              }`}</BaseText>
            ) : null}
          </RowView>
        </View>
      </View>
    </Modal>
  );
};

const stylesModal = StyleSheet.create({
  wrap: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,.5)',
    ...CommonProperties.centerAlignment,
    ...CommonProperties.p3,
  },
  innerWrap: {
    width: '100%',
    backgroundColor: 'white',
    ...CommonProperties.p3,
    ...CommonProperties.borderRadius2,
    ...CommonProperties.centerItems,
    ...CommonProperties.py5,
  },
  subtitle: {
    color: Color.text.medium,
    ...CommonProperties.h3,
    ...CommonProperties.px5,
    textAlign: 'center',
  },
  title: {
    color: Color.primary,
    ...CommonProperties.h1,
    ...CommonProperties.my3,
  },
  border: {
    borderTopColor: Color.text.low,
    borderTopWidth: 1,
    width: '100%',
    ...CommonProperties.my5,
  },
  details: {
    ...CommonProperties.pb5,
    ...CommonProperties.mt2,
  },
  date: {
    ...CommonProperties.h3,
    ...CommonProperties.mr5,
  },
  cancel: {
    position: 'absolute',
    top: scale(14),
    right: scale(12),
  },
});

export default SubmitExpenseModal;
